import { useNavigate, useParams } from "react-router-dom";
import useTranslator from "../hooks/useTranslator";
import { Col, Container, Row } from "react-bootstrap";
import { useContext, useEffect, useState } from "react";
import ReactMultiSelectCheckboxes from "react-multiselect-checkboxes";
import constants from "../Utils/constants";
import { haveValue } from "../helper/common";
import { toast } from "react-toastify";
import TenantContext from "../context/tenant/TenantContext";
import AuthContext from "../context/auth/AuthContext";
import moment from "moment";

const AddGuarantor = () => {
  const navigate = useNavigate();
  const { _t } = useTranslator();
  const { guarantorId = null } = useParams();
  const { loadUser } = useContext(AuthContext);
  const {
    createBasicGuarantorAccount,
    guarantorAddedDetails,
    updateBasicGuarantorAccount,
  } = useContext(TenantContext);
  const [selectBtn, setSelectBtn] = useState(_t("select") + "...");
  const [selectedDocuments, setSelectedDocuments] = useState([]);
  const [formData, setFormData] = useState({
    edit_id: null,
    fname: "",
    lname: "",
    employment_status: "",
    employment_category: "",
    gurantor_relation: "",
    protected_housing: null,
    current_annual_income: null,
    post_code: null,
    dob: null,
    identity_number: "",
  });
  const [haveDni, setHaveDni] = useState(true);

  useEffect(() => {
    if (haveValue(guarantorId)) {
      guarantorAddedDetails(guarantorId)
        .then((res) => {
          const temp_data = res.success_res;
          setFormData({
            edit_id: temp_data?._id,
            fname: temp_data?.guarantor_id?.fname,
            lname: temp_data?.guarantor_id?.lname,
            employment_status: temp_data?.guarantor_id?.employment_status,
            employment_category: temp_data?.guarantor_id?.employment_category,
            gurantor_relation: temp_data?.gurantor_relation,
            protected_housing: temp_data?.guarantor_id?.protected_housing,
            current_annual_income:
              temp_data?.guarantor_id?.current_annual_income,
            post_code: temp_data?.guarantor_id?.post_code,
            dob: moment(temp_data?.guarantor_id?.dob).format("YYYY-MM-DD"),
            identity_number: haveValue(temp_data?.guarantor_id?.dni_nie)
              ? temp_data?.guarantor_id?.dni_nie
              : temp_data?.guarantor_id?.passport_id,
          });
          setHaveDni(haveValue(temp_data?.guarantor_id?.dni_nie));
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, []);

  const allDocuments = [
    {
      value: constants.regulatory_agreement_in_case_of_divorce_separation,
      label: _t(
        "regulatoryAgreementInCaseOfDivorceSeparation",
        "Public Housing Certificates"
      ),
    },
    {
      value: constants.revalued_pension_certificate,
      label: _t("revaluedPensionCertificate", "Public Housing Certificates"),
    },
    {
      value: constants.family_book_marriage_civil_partnership_birth_certificate,
      label: _t(
        "familyBookMarriageCivilPartnershipBirthCertificate",
        "Public Housing Certificates"
      ),
    },
    {
      value: constants.certificate_of_social_security_compliance,
      label: _t(
        "certificateProvingDisabilityStatus",
        "Public Housing Certificates"
      ),
    },
  ];

  const handlePropSelect = async (e) => {
    const temp = e.map((val) => ({ label: val?.label, value: val?.value }));
    var placeholder_string = [];

    const selectedValues = temp.map((item) => item.value);

    const tempArr = allDocuments.filter((val) =>
      selectedValues.includes(val?.value)
    );

    tempArr.forEach((val) => {
      placeholder_string.push(
        <span className="placeholder_string">{val?.label}</span>
      );
    });

    if (placeholder_string.length == 0) setSelectBtn(_t("select") + "...");
    else setSelectBtn(placeholder_string);
    setSelectedDocuments(temp);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    console.log(name, value);
    setFormData((prev) => {
      const updatedForm = {
        ...prev,
        [name]: value,
      };

      if (name === "protected_housing") {
        updatedForm[name] = value === "true";
      }

      // Reset subcategory if employment status changes
      if (name === "employment_status") {
        updatedForm.employment_category = "";
      }

      return updatedForm;
    });
  };

  const requiresSubcategory = (status) => {
    return [constants.public_servant, constants.employed].includes(status);
  };

  const handleNavigateHome = () => {
    navigate("/tenant");
  };

  const handleCreateAccount = () => {
    if (
      !haveValue(formData?.fname) ||
      !haveValue(formData?.lname) ||
      !haveValue(formData?.gurantor_relation) ||
      !haveValue(formData?.current_annual_income) ||
      !haveValue(formData?.employment_status) ||
      !haveValue(formData?.post_code) ||
      !haveValue(formData?.dob) ||
      !haveValue(formData?.identity_number) ||
      (requiresSubcategory(formData?.employment_status) &&
        !haveValue(formData?.employment_category)) ||
      (formData.protected_housing === true && selectedDocuments.length == 0)
    ) {
      toast.error(_t("allFieldsAreRequired"));
    } else {
      const updatedData = {
        ...formData,
        [haveDni ? "dni_nie" : "passport_id"]: formData?.identity_number,
        [!haveDni ? "dni_nie" : "passport_id"]: "",
      };
      delete updatedData?.identity_number;

      const temp_data = { ...updatedData, selectedDocuments };
      if (haveValue(guarantorId)) {
        updateBasicGuarantorAccount(temp_data)
          .then((res) => {
            loadUser("tenant");
            navigate(`/guarantor/details/${guarantorId}`);
          })
          .catch((err) => {
            console.log(err);
            toast.error(_t("errorOccured"));
          });
      } else {
        createBasicGuarantorAccount(temp_data)
          .then((res) => {
            loadUser("tenant");
            navigate("/guarantor/setup");
          })
          .catch((err) => {
            console.log(err);
            toast.error(_t("errorOccured"));
          });
      }
    }
  };

  return (
    <>
      <div className="step-form-main-wrapper">
        <div className="d-flex step-absolute-header step-form-header">
          <Container className="p-0 text-center back-btn ">
            <div className="">
              <a href={undefined} onClick={handleNavigateHome}>
                <img src="/images/back-btn-white.svg" alt="" />
              </a>
            </div>
          </Container>
          <h3 class="step-form-name">
            <img src="/images/profile-icon.svg" alt="" />
            <span>{_t("createGuarantor")}</span>
          </h3>
        </div>
        <div className="steps-wrapper ">
          <Row>
            <Col xl={6}>
              <div className="forminput ">
                <label htmlFor="" className="percentage_salary_p ">
                  {_t("firstName")}
                </label>
                <input
                  type="text"
                  className="form-control"
                  name="fname"
                  onChange={handleInputChange}
                  placeholder={_t("enterValue")}
                  value={formData?.fname}
                />
              </div>
            </Col>
            <Col xl={6}>
              <div className="forminput ">
                <label htmlFor="" className="percentage_salary_p ">
                  {_t("lastName")}
                </label>
                <input
                  type="text"
                  className="form-control"
                  name="lname"
                  onChange={handleInputChange}
                  placeholder={_t("enterValue")}
                  value={formData?.lname}
                />
              </div>
            </Col>
            <Col xl={12} className="two-items-row mb-0">
              <div className="forminput ">
                <label htmlFor="" className="percentage_salary_p ">
                  {_t("employmentStatus")}
                </label>
                <select
                  className="form-control"
                  name="employment_status"
                  value={formData?.employment_status}
                  onChange={handleInputChange}
                >
                  <option value="">{_t("pleaseSelect")}</option>
                  <option value={constants.employed}>{_t("employed")}</option>
                  <option value={constants.self_employed}>
                    {_t("selfEmployed")}
                  </option>
                  <option value={constants.student}>{_t("student")}</option>
                  <option value={constants.unemployed}>
                    {_t("unemployed")}{" "}
                  </option>
                  <option value={constants.retired}>{_t("retired")} </option>
                  <option value={constants.public_servant}>
                    {_t(constants.public_servant)}
                  </option>
                </select>
              </div>
              {/* </Col> */}
              {(requiresSubcategory(formData?.employment_status) ?? "") && (
                // <Col xl={6}>
                <div className="forminput">
                  <p className="percentage_salary_p">
                    {_t(
                      "employmentCategory",
                      "Employment subcategory title in tenant basic information"
                    )}
                  </p>
                  <select
                    className="form-control"
                    name="employment_category"
                    value={formData?.employment_category}
                    onChange={handleInputChange}
                  >
                    <option value="">{_t("pleaseSelect")}</option>
                    {(() => {
                      let subcategories = [];
                      if (
                        formData?.employment_status === constants.public_servant
                      ) {
                        subcategories = constants.public_servant_subcategories;
                      } else if (
                        formData?.employment_status === constants.employed
                      ) {
                        subcategories = constants.employed_subcategories;
                      }

                      return subcategories.map((item) => (
                        <option key={item} value={item}>
                          {_t(item)}
                        </option>
                      ));
                    })()}
                  </select>
                </div>
              )}
            </Col>
            <Col xl={6}>
              <div className="forminput ">
                <label htmlFor="" className="percentage_salary_p ">
                  {_t("postCode")}
                </label>
                <input
                  type="number"
                  name="post_code"
                  className="form-control"
                  value={formData?.post_code}
                  onChange={handleInputChange}
                />
              </div>
            </Col>
            <Col xl={6}>
              <div className="forminput ">
                <label htmlFor="" className="percentage_salary_p ">
                  {_t("dateOfBirth")}
                </label>
                <input
                  className="form-control"
                  name="dob"
                  onChange={handleInputChange}
                  type="date"
                  value={formData?.dob}
                  placeholder={`${_t("select")} ${_t("dateOfBirth")}`}
                />
              </div>
            </Col>

            <div>
              <p className="percentage_salary_p">
                {_t("doYouHave", "Used this title in add guarantor form")}
              </p>
              <div className="two-items-row mb-0">
                <label class="customradiobar forminput cursor-pointer">
                  <input
                    type="radio"
                    name="identity_number_radio"
                    onChange={() => {
                      setHaveDni(true);
                      handleInputChange({
                        target: { name: "identity_number", value: "" },
                      });
                    }}
                    checked={haveDni}
                  />
                  <div class="boxes">{_t("dniNie")}</div>
                </label>
                <label class="customradiobar forminput cursor-pointer">
                  <input
                    type="radio"
                    name="identity_number_radio"
                    onChange={() => {
                      setHaveDni(false);
                      handleInputChange({
                        target: { name: "identity_number", value: "" },
                      });
                    }}
                    checked={!haveDni}
                  />
                  <div class="boxes">{_t("passport")}</div>
                </label>
              </div>
            </div>

            <Col xl={6}>
              <div className="forminput ">
                <label htmlFor="" className="percentage_salary_p ">
                  {_t(haveDni ? "enterDniNieNumber" : "enterPassportNumber")}
                </label>
                <input
                  type="text"
                  className="form-control"
                  name="identity_number"
                  onChange={handleInputChange}
                  value={formData?.identity_number}
                />
              </div>
            </Col>
            <Col xl={6}>
              <div className="forminput ">
                <label htmlFor="" className="percentage_salary_p ">
                  {_t("relationshipWithGuarantor")}
                </label>
                <select
                  className="form-control"
                  name="gurantor_relation"
                  id=""
                  value={formData?.gurantor_relation}
                  onChange={handleInputChange}
                >
                  <option value="" selected>
                    {_t("pleaseSelect")}
                  </option>
                  <option value="parent">{_t("parent")}</option>
                  <option value="Family">{_t("Family")}</option>
                  <option value="relative">{_t("relative")}</option>
                  <option value="partner">{_t("partner")}</option>
                  <option value="company">{_t("company")}</option>
                  <option value="other">{_t("other")}</option>
                </select>
              </div>
            </Col>
            <Col xl={12}>
              <div className="forminput ">
                <label htmlFor="" className="percentage_salary_p ">
                  {_t("annualIncome")}
                </label>
                <input
                  type="number"
                  className="form-control"
                  name="current_annual_income"
                  onChange={handleInputChange}
                  onKeyDown={(e) => {
                    if ([".", ",", "e", "-"].includes(e.key)) {
                      e.preventDefault();
                    }
                  }}
                  placeholder={_t("enterAnnualIncome")}
                  value={formData?.current_annual_income}
                />
              </div>
            </Col>

            <div>
              <p className="percentage_salary_p">
                {_t(
                  "areYouApplyingOrDoesYourProfileApplyForAPublicHousingProperty",
                  "Public Housing Popup title"
                )}
              </p>
              <div className="two-items-row mb-0">
                <label class="customradiobar forminput cursor-pointer">
                  <input
                    type="radio"
                    name="protected_housing"
                    onChange={handleInputChange}
                    checked={formData.protected_housing === false}
                    value="false"
                  />
                  <div class="boxes">{_t("no")}</div>
                </label>
                <label class="customradiobar forminput cursor-pointer">
                  <input
                    type="radio"
                    name="protected_housing"
                    onChange={handleInputChange}
                    checked={formData.protected_housing === true}
                    value="true"
                  />
                  <div class="boxes">{_t("yes")}</div>
                </label>
              </div>
            </div>

            {formData.protected_housing === true && (
              <div>
                <p className="percentage_salary_p">{_t("documentType")}</p>
                <div className="link-property prime-selectmulti multiselect-tenant custom-select-design">
                  <ReactMultiSelectCheckboxes
                    // key={JSON.stringify(selectedDocuments)}
                    isMulti
                    name="protected_housing_properties"
                    id="protected_housing_properties"
                    options={allDocuments}
                    className="basic-multi-select form-control link_prop_select"
                    classNamePrefix="select"
                    placeholderButtonLabel={selectBtn}
                    getDropdownButtonLabel={function getDropdownButtonLabe(
                      _ref3
                    ) {
                      return selectBtn;
                    }}
                    selectedOptions={selectedDocuments}
                    onChange={handlePropSelect}
                    defaultValue={selectedDocuments}
                  />
                </div>
              </div>
            )}
          </Row>
          <div className="d-flex align-items-center btngroup gap-3 step-btns-group   mobile-btn-box">
            <button
              className="btn btnoutline bg-none"
              onClick={handleNavigateHome}
            >
              {_t("goBack")}
            </button>
            <button
              className="btn btnorange step-btn"
              onClick={handleCreateAccount}
            >
              {_t("next")}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddGuarantor;
